import { DateUtils } from 'react-day-picker';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';

export const initModifiers = (props) => {
  // populate the myEvents property with ALL the events. This property will be referenced inside modifiersStyles for styling.
  return {
    myEvents: [...props.db.map(el => new Date(el.day))]
  }
}

export const modifiersStyles = {
  myEvents: {
    backgroundColor: '#dceffd',
    fontWeight: 600,
    color: '#192A3E',
  },
  // change the default background-color for "selected" ("selected" comes by default, myEvents is created by me)
  selected: {
    backgroundColor: '#9192ff',
  }
};

export function parseDate(str, format, locale) {
  const parsed = dateFnsParse(str, format, new Date(), { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

export function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale });
}